module.exports = {"api":"https://backend.kgvb-cloudflare.penduline.mercadia.cz/"}